import * as React from 'react'
import { SVGProps } from 'react'
export const HrIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={51}
    height={51}
    fill="none"
    {...props}
  >
    <rect
      width={49.5}
      height={49.5}
      x={0.75}
      y={0.75}
      fill="#F3F3F3"
      stroke="#F3F3F3"
      strokeWidth={1.5}
      rx={24.75}
    />
    <path
      fill="#FF18BD"
      fillRule="evenodd"
      d="M25.5 1.5c13.255 0 24 10.747 24 24 0 13.264-10.746 24.002-24 24.002-13.253 0-24-10.739-24-24.002 0-13.253 10.747-24 24-24Zm12.169 33.914c-.207.129-.486.24-.81.338-.656.198-1.585.371-2.711.515-2.258.29-5.365.467-8.79.467-3.425 0-6.532-.178-8.79-.467-1.126-.144-2.055-.317-2.71-.515-.325-.099-.605-.21-.81-.338a1.47 1.47 0 0 1-.053-.034v2.02c0 .873 5.535 1.582 12.363 1.582 6.828 0 12.363-.709 12.363-1.582v-2.02a1.735 1.735 0 0 1-.052.034Zm-12.311-2.218c-6.828 0-12.363.708-12.363 1.582 0 .873 5.536 1.58 12.363 1.58s12.362-.707 12.363-1.58c0-.874-5.535-1.582-12.363-1.582ZM22.837 17.05a3.33 3.33 0 0 1-2.514 1.826l-5.654.814 4.096 3.982a3.33 3.33 0 0 1 .96 2.955l-.974 5.629 5.053-2.665a3.33 3.33 0 0 1 3.107 0l5.053 2.665-.973-5.629a3.33 3.33 0 0 1 .96-2.955l4.097-3.982-5.655-.814a3.33 3.33 0 0 1-2.513-1.826l-2.522-5.126-2.521 5.126Z"
      clipRule="evenodd"
    />
  </svg>
)
